import Action from 'constants/action-types'
import {
  SET_ATTRIBUTES,
  SET_ATTRIBUTES_TREE,
  SET_FETCHING_ATTRIBUTES,
  SET_ATTRIBUTE_VALUES,
  SET_FETCHING_ATTRIBUTE_VALUES,
} from 'constants/action-types'
import type { AttributesState } from 'types/search/attributes'

const initialState: AttributesState = {
  attributes: [],
  treeData: [],
  isFetching: false,
  attributeValues: [],
  isFetchingValues: false,
}

export default (
  state: AttributesState = initialState,
  action: Action,
): AttributesState => {
  switch (action.type) {
    case SET_ATTRIBUTES:
      return {
        ...state,
        attributes: action.payload as AttributesState['attributes'],
      }

    case SET_ATTRIBUTES_TREE:
      return {
        ...state,
        treeData: action.payload as AttributesState['treeData'],
      }

    case SET_FETCHING_ATTRIBUTES:
      return {
        ...state,
        isFetching: action.payload,
      }

    case SET_ATTRIBUTE_VALUES:
      return {
        ...state,
        attributeValues: action.payload as AttributesState['attributeValues'],
      }

    case SET_FETCHING_ATTRIBUTE_VALUES:
      return {
        ...state,
        isFetchingValues: action.payload,
      }

    default:
      return state
  }
}
